import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconSize } from '@panaya/ui/p-icon';
import { LabelTypeEnum } from '../../p-status-main-label';
import { PFieldAbstractComponent } from '../p-field-abstract';
import { IconObject } from './IconObject';

@Component({
    selector: 'p-field-status-sub-label',
    template: `
        <p-field [label]="label" [isReadOnly]="true">
            <div slot="readMode" style="width: 160px;">
                <p-status-sub-label
                    style="float: left;"
                    [label]="value?.label ?? ''"
                    [type]="value?.type"
                    [attr.automation-id]="'p-status-sub-label_' + label"
                ></p-status-sub-label>
                <p-icon
                    *ngFor="let iconObj of value?.iconsWithToolTips"
                    style="padding-left: 5px;"
                    [name]="iconObj.icon"
                    [size]="value?.iconSize ?? 'md'"
                    [matTooltip]="iconObj.iconTooltip"
                ></p-icon>
            </div>
        </p-field>
    `,
    styleUrls: ['./p-field-status-sub-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldStatusSubLabelComponent
        }
    ],
    exportAs: 'pFieldStatusSubLabel'
})
export class PFieldStatusSubLabelComponent extends PFieldAbstractComponent<SubLabelStatus> {
    @Input() label = '';

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }
}

interface SubLabelStatus {
    id: number;
    label: string;
    type: LabelTypeEnum;
    iconSize: IconSize;
    iconsWithToolTips: IconObject[];
}
